import { useCreateLoyaltyConfigMutation } from '@/services/innovorder/modules/modules.endpoints';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

const useCreateSplioConfig = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const [createConfig, { isLoading: isCreating }] = useCreateLoyaltyConfigMutation();
    const {
        control,
        handleSubmit,
        reset,
        formState: { isDirty },
    } = useForm<{ splioApiKey: string }>({
        mode: 'all',
    });

    const onSubmit = (data: { splioApiKey: string }) => {
        createConfig({
            restaurantId: Number(restaurantId),
            apiKey: data.splioApiKey,
            provider: 'splio',
        });
        reset();
    };
    return { createConfig, isCreating, onSubmit, control, handleSubmit, isDirty };
};

export default useCreateSplioConfig;
